import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'

import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import ErrorMessage from '../common/ErrorMessage'

class NoServerError extends Component {
  render () {
    if (!this.props.error) { return <div className='error-container' /> } else {
      return (
        <div>
          <Row middle='xs' center='xs'>
            <Col xs={12} >
              <div id='loading' className='centered'>
                <div className='loadingInnerContainer'>
                  <ErrorMessage error={this.props.error} />
                </div>
              </div>
            </Col>
          </Row>
          {this.props.retry
            ? <Row center='xs'>
              <Col xs={12} sm={8} md={4} lg={3}>
                <br /><br />
                <RBButton variant='contained' fullWidth label={localize('error.serverNotAvailable.retry')} primary onClick={this.props.retry} />
              </Col>
            </Row> : null}
        </div>
      )
    }
  }
}

export default NoServerError



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/NoServerError.js